import React from "react";
import { uuid } from "../../../helpers/utils";
import { IRELAND_EMPLOYEE_GUIDE_URL, SOUTH_AFRICA_EMPLOYEE_GUIDE_PDF_URL } from "../../../utility/constants";
import LinkWithRedirect from "../../common/LinkWithRedirect";
import { DefaultConfigType, TextBuilderConfigType, getDefaultValues } from "../../TextBuilder";
import { HVH_COLORS } from "../../../config/palette";

const defaultConfig: DefaultConfigType = ({ getMessage }) => [
  {
    text: getMessage(
      "Checklist-docUpload-description",
      `Please take a moment to review the acceptable documents information and ensure you have the right documents on hand before beginning the process: Click here to see examples of acceptable documents.`
    ),
    key: uuid(),
  },
];

export const getBlurbConfig: TextBuilderConfigType = (arb) => ({
  ...getDefaultValues(defaultConfig(arb)),

  IE: [
    {
      key: uuid(),
      text: arb.getMessage(
        "Checklist-docUpload-RTW-MainText-IE",
        "To begin work, you must provide documentation that establishes both your identity and work authorization for Amazon in Ireland. Follow the steps below to complete this process."
      ),
    },
    {
      prefixText: "1. ",
      key: uuid(),
      text: arb.formatMessage("Checklist-docUpload-RTW-Examples-IE", {
        link: <LinkWithRedirect link={IRELAND_EMPLOYEE_GUIDE_URL} messageKey="Checklist-MainPage-Link" />,
      }),
    },
    {
      prefixText: "2. ",
      key: uuid(),
      text: arb.getMessage(
        "Checklist-docUpload-RTW-Scans-IE",
        "Upload images or scans of your original documentation below."
      ),
    },
    {
      key: uuid(),
      text: arb.getMessage(
        "Checklist-docUpload-RTW-Withdraw-IE",
        "If you don’t provide documentation, you will not be allowed to start work and your start date may be pushed out or your offer of employment may be withdrawn."
      ),
    },
  ],

  ZA: [
    {
      key: uuid(),
      text: arb.getMessage(
        "Checklist-docUpload-RTW-MainText-ZA",
        "To begin work, you must provide documentation that establishes both your identity and work authorization for Amazon in South Africa. Follow the steps below to complete this process."
      ),
    },
    {
      key: uuid(),
      text: arb.formatMessage("Checklist-docUpload-RTW-Documentation-ZA", {
        link: <LinkWithRedirect link={SOUTH_AFRICA_EMPLOYEE_GUIDE_PDF_URL} messageKey="Checklist-MainPage-Link" />,
      }),
    },
    {
      key: uuid(),
      text: arb.getMessage(
        "Checklist-docUpload-RTW-Withdraw-ZA",
        "If you are unable to provide documentation, you will not be allowed to start work and your start date may be pushed out or your offer of employment may be withdrawn."
      ),
    },
  ],
});
